/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_PrahanoiInputs */

const cs_enum_prahanoi = /** @type {(inputs: Enum_PrahanoiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prahanoi`)
};

const en_enum_prahanoi = /** @type {(inputs: Enum_PrahanoiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prahanoi`)
};

/**
* | output |
* | --- |
* | "Prahanoi" |
*
* @param {Enum_PrahanoiInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_prahanoi = /** @type {((inputs?: Enum_PrahanoiInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_PrahanoiInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_prahanoi(inputs)
	return cs_enum_prahanoi(inputs)
});